/* sbc.js — Shop By Categories JS
   Exposes window.SBCInit(root) so section can prefer this optimized implementation.
   Responsibilities:
   - Lazy populate desktop/mobile background images via IntersectionObserver
   - Respect save-data / reduced-motion preferences
   - Update on breakpoint changes and respond to custom 'repaint' events
*/

(function () {
  'use strict';

  function createSBCInit() {
    function initSingle(root) {
      if (!root) return;
      const cards = Array.from(root.querySelectorAll('.sbcCard'));
      if (!cards.length) return;

      const mq = window.matchMedia('(min-width:768px)');
      const saveData = (navigator.connection && navigator.connection.saveData) || false;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reduced = saveData || prefersReducedMotion;

      const pickURL = card => (mq.matches ? card.getAttribute('data-bg-desktop') : card.getAttribute('data-bg-mobile'));

      const setBG = (card) => {
        const bg = card.querySelector('.sbcCard__bg');
        if (!bg || bg.dataset.set === '1') return;
        const url = pickURL(card);
        if (url) {
          const img = new Image();
          img.src = url;
          img.onload = function () {
            bg.style.backgroundImage = 'url(' + url + ')';
            bg.dataset.set = '1';
          };
          setTimeout(() => {
            if (!bg.dataset.set) {
              bg.style.backgroundImage = 'url(' + url + ')';
              bg.dataset.set = '1';
            }
          }, 1200);
        }
      };

      const setAllImmediate = () => cards.forEach(setBG);

      if ('IntersectionObserver' in window && !reduced) {
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              setBG(e.target);
              obs.unobserve(e.target);
            }
          });
        }, { rootMargin: '200px 0px' });

        cards.forEach(card => io.observe(card));
      } else {
        if ('requestIdleCallback' in window && !reduced) {
          requestIdleCallback(setAllImmediate, { timeout: 700 });
        } else {
          setTimeout(setAllImmediate, 60);
        }
      }

      const onMQChange = () => {
        cards.forEach(c => {
          const bg = c.querySelector('.sbcCard__bg');
          if (bg) {
            bg.removeAttribute('data-set');
            bg.style.backgroundImage = '';
          }
        });
        if ('requestIdleCallback' in window && !reduced) requestIdleCallback(setAllImmediate, { timeout: 700 });
        else setAllImmediate();
      };

      if (mq.addEventListener) mq.addEventListener('change', onMQChange);
      else if (mq.addListener) mq.addListener(onMQChange);
      else window.addEventListener('resize', onMQChange);

      window.addEventListener('repaint', onMQChange, { passive: true });

      root.SBC = {
        refresh: onMQChange,
        setAll: setAllImmediate
      };
    }

    function init(root) {
      if (root) initSingle(root);
      else {
        const roots = Array.from(document.querySelectorAll('.sbc'));
        roots.forEach(r => initSingle(r));
      }
    }

    return init;
  }

  if (!window.SBCInit) {
    window.SBCInit = createSBCInit();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => { if (window && window.SBCInit) window.SBCInit(); }, { timeout: 700 });
    } else {
      setTimeout(() => { if (window && window.SBCInit) window.SBCInit(); }, 200);
    }
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => { if (window && window.SBCInit) window.SBCInit(); }, { timeout: 700 });
      } else {
        setTimeout(() => { if (window && window.SBCInit) window.SBCInit(); }, 200);
      }
    });
  }
})();
